import classNames from 'classnames';
import * as React from 'react';
import Button, { ButtonProps } from '../../Button';
import SaveButton from '../../SaveButton';
import styles from './style.m.less';

export const SIZES_CLASSMAP = {
    DEFAULT: styles.default,
    SMALL: styles.small,
    TITLE: styles.title,
};

type Props = {
    size?: keyof typeof SIZES_CLASSMAP;
};

export const InputButton = ({ className, size = 'DEFAULT', ...otherProps }: Props & ButtonProps) => (
    <Button
        isSmall={size !== 'SMALL'}
        className={classNames(styles.inputButton, SIZES_CLASSMAP[size], className)}
        {...otherProps}
    />
);

export const InputButtonIcon = ({ className, size = 'DEFAULT', ...otherProps }: Props & ButtonProps) => (
    <Button
        kind="PLAIN"
        className={classNames(styles.inputButtonIcon, SIZES_CLASSMAP[size], className)}
        {...otherProps}
    />
);

export const InputSaveButton = ({
    className,
    size = 'DEFAULT',
    ...otherProps
}: Props & React.ComponentPropsWithoutRef<typeof SaveButton>) => (
    <SaveButton
        isSmall={size !== 'SMALL'}
        className={classNames(styles.inputButton, SIZES_CLASSMAP[size], className)}
        {...otherProps}
    />
);
